module.exports = __webpack_public_path__ + "static/media/flag.40df6cdc.png";